import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import '../../Styles/Header.css'
import Appbar from '../../Component/NavPannel/Appbar';
import TransactionsLayout from '../../Component/Layouts/TransactionsLayout';


const mdTheme = createTheme();

function Transactions() {
  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <Appbar mainpage="Home" subpage="Transactions Management"/>
        < TransactionsLayout/>
      </Box>
    </ThemeProvider>
  );
}

export default function TransactionsManagement() {
  return <Transactions />
}